import { render, staticRenderFns } from "./TaxInfoSection.vue?vue&type=template&id=1cded47a"
import script from "./TaxInfoSection.vue?vue&type=script&lang=js"
export * from "./TaxInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports